import React from "react";
import PropTypes from "prop-types";

function Pane(props) {
    return <div>{props.children}</div>;
}

Pane.propTypes = {
    paneId: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    children: PropTypes.any,
};

export default Pane;
